import axios from "axios";

export const baseUrl = 'https://gwadmin.lzpay.com/'//基础请求地址
// export const baseUrl = 'http://localhost:18081'//基础请求地址

let request = axios.create({
    baseURL: baseUrl,
    timeout: 50000//超时的时间设置
})
// 2. request实例添加请求与响应拦截器
request.interceptors.request.use((config) => {
    // config配置对象，headers属性请求头，经常给服务器端携带公共参数
    // 返回配置对象
    return config
})

request.interceptors.response.use(
    (response) => {
        // 兼容后端返回200但是body为空的情况
        const data = response.data
        if (data === null || data === '' || typeof data === 'undefined') {
            console.warn(`【接口返回空响应】url:${response.config.url}`)
        }
        return data
    },
    (error) => {
        let message = '';
        // 【关键】可选链判断，防止 error.response 为 undefined
        if (!error.response) {
            // 场景：超时、断网、JSON解析失败(200空body)、网关阻断
            if (error.message.includes('timeout')) {
                message = "请求超时，请检查网络"
            } else {
                message = "网络异常或服务返回数据格式错误"
            }
        } else {
            // 有HTTP响应，才读取status
            const status = error.response.status;
            switch (status) {
                case 401:
                    message = "TOKEN过期"
                    break;
                case 403:
                    message = "无权访问"
                    break;
                case 404:
                    message = "请求地址错误"
                    break;
                case 500:
                    message = "服务器出现问题"
                    break;
                default:
                    message = `请求错误${status}`
                    break;
            }
        }
        return Promise.reject(message);
    }
)

// 对外暴露
export default request;